import { API, graphqlOperation } from 'aws-amplify'

const updateFloorWarden = `mutation UpdateFloorWarden($input: floorWardenInput, $version: Int!) {
    updateFloorWarden(input: $input, expectedVersion: $version) {
         email
         firstName
         lastName
         phone
         suite
         floor
         position
         type
         tenantId
         buildingId
         buildingName
         tenantName
         propertyId
         version
    }
}`

const UpdateFloorWarden = async (input) => {
    let response = ''
    try {
        response = await API.graphql(graphqlOperation(updateFloorWarden, input))
    } catch (e) {
        response = e
    }
    return response
}

export default UpdateFloorWarden
